import { render, staticRenderFns } from "./donorfuse.vue?vue&type=template&id=94058550&scoped=true&"
import script from "./donorfuse.vue?vue&type=script&lang=js&"
export * from "./donorfuse.vue?vue&type=script&lang=js&"
import style0 from "./donorfuse.vue?vue&type=style&index=0&id=94058550&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94058550",
  null
  
)

export default component.exports